/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState, useRef } from "react";
import { Button, Form, Col, Row, Table } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import { env } from "../../../env";
import {
  Doughnut,
  Bar,
  getDatasetAtEvent,
  getElementAtEvent,
  getElementsAtEvent,
} from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";
import { InteractionItem } from "chart.js";
import SVG from "react-inlinesvg";
import BootstrapTable from "react-bootstrap-table-next";

import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";

import { LayoutSplashScreen } from "../../../_metronic/layout";
import {
  checkMenu,
  formatCurrency,
  formatQuantity,
  showErrorDialog,
} from "../../utility";
import { selectMe, selectUser } from "../../modules/Auth/_redux/authRedux";
import {
  resetData,
  selectDashboard,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchDashboard,
  setPermisionDashboard,
  selectPermissionDashboard,
  selectPermissionList,
  setPermisionList,
} from "./dashboardSlice";
import {
  fetchIdMenuFav,
  fetchMenuTab,
  selectIdMenuFav,
  selectLoadingMenu,
  selectMenuTab,
} from "../menu/menuSlice";
import { ModalStocktake } from "./ModalStocktake";
export const DashboardPage = ({ className, symbolShape, baseColor }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(selectUser);
  const loading = useSelector(selectLoading);
  const loadingMenu = useSelector(selectLoadingMenu);
  const data = useSelector(selectDashboard);
  const dataMe = useSelector(selectMe);
  const dataIdMenuFav = useSelector(selectIdMenuFav);
  const dataMenuTab = useSelector(selectMenuTab);
  const dataMenuList = useSelector(selectPermissionList);

  const dataQuikLink = dataIdMenuFav === null ? [] : dataIdMenuFav;

  ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    BarElement,
    Title
  );

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load

      await dispatch(fetchDashboard());
      await dispatch(
        fetchMenuTab({
          menu_url: "/dashboard",
        })
      );
      await dispatch(fetchIdMenuFav(dataMe.user_id));
    }
    fetchMyAPI();
  }, [dispatch]);

  const [show, setShow] = useState(false);
  const [getData, setGetData] = useState(false);

  console.log(dataMenuTab, "dataMenuTab");
  console.log(dataMenuList, "dataMenuList");

  const [fields, setFields] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  useEffect(() => {
    if (dataMenuTab && dataMenuTab.length > 0) {
      const data = dataMenuTab.map((item) => item.menu_name);
      dispatch(setPermisionList(data));
      console.log(data, "data");
    }
  }, [dataMenuTab]);

  return loading || loadingMenu ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {checkMenu(dataMenuList, "dashboard") ? (
        <>
          {data && (
            <>
              <div
                className="container  pl-0 pr-0"
                style={{ marginBottom: "35px" }}
              >
                {/* Card */}
                <div className="row">
                  {/* Inbound Pending */}
                  <div className="col-md-3 col-xs-12 mb-3 ">
                    <div
                      className={`card card-custom p-0 m-0 `}
                      style={{
                        backgroundSize: "cover",
                        borderRadius: "10px",
                      }}
                    >
                      <div className="card-body p-0 m-0 ">
                        <div className="card-body">
                          <h3 className="title text-dark font-size-h5 font-weight-boldest">
                            Inbound Pending
                          </h3>
                          <div className="d-flex justify-content-between">
                            <div className=" text-success font-weight-bolder display4">
                              <p>{formatQuantity(data.inbound_pending)}</p>
                            </div>
                            <div className="text-dark font-weight-bolder display4 mt-2">
                              <div className="d-flex btn btn-icon btn-light  btn-sm ">
                                <span className="svg-icon svg-icon-md svg-icon-primary">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/Inbount.svg"
                                    )}
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Outbound Pending */}
                  <div className="col-md-3 col-xs-12 mb-3 ">
                    <div
                      className={`card card-custom p-0 m-0 `}
                      style={{
                        backgroundSize: "cover",
                        borderRadius: "10px",
                      }}
                    >
                      <div className="card-body p-0 m-0 ">
                        <div className="card-body">
                          <h3 className="title text-dark font-size-h5 font-weight-boldest">
                            Outbound Pending
                          </h3>
                          <div className="d-flex justify-content-between">
                            <div className=" text-success font-weight-bolder display4">
                              <p>{formatQuantity(data.outbound_pending)}</p>
                            </div>
                            <div className="text-dark font-weight-bolder display4 mt-2">
                              <div className="d-flex btn btn-icon btn-light  btn-sm ">
                                <span className="svg-icon svg-icon-md svg-icon-primary">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/Outbount.svg"
                                    )}
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Available Stock*/}
                  <div className="col-md-3 col-xs-12 mb-3 ">
                    <div
                      className={`card card-custom p-0 m-0 `}
                      style={{
                        backgroundSize: "cover",
                        borderRadius: "10px",
                      }}
                    >
                      <div className="card-body p-0 m-0 ">
                        <div className="card-body">
                          <h3 className="title text-dark font-size-h5 font-weight-boldest">
                            Available Stock
                          </h3>
                          <div className="d-flex justify-content-between">
                            <div className=" text-dark font-weight-bolder display4">
                              <p>{formatQuantity(data.available_stock)}</p>
                            </div>
                            <div className="text-dark font-weight-bolder display4 mt-2">
                              <div className="d-flex btn btn-icon btn-light  btn-sm ">
                                <span className="svg-icon svg-icon-md svg-icon-primary">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/Stock.svg"
                                    )}
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Repair */}
                  <div className="col-md-3 col-xs-12 mb-3 ">
                    <div
                      className={`card card-custom p-0 m-0 `}
                      style={{
                        backgroundSize: "cover",
                        borderRadius: "10px",
                      }}
                    >
                      <div className="card-body p-0 m-0 ">
                        <div className="card-body">
                          <h3 className="title text-dark font-size-h5 font-weight-boldest">
                            Capacity
                          </h3>
                          <div className="d-flex justify-content-between">
                            <div className=" text-dark font-weight-bolder display4">
                              <p>{formatQuantity(data.capacity)}</p>
                            </div>
                            <div className="text-muted align-self-end">
                              <p>/ {formatQuantity(data.max_capacity)}</p>
                            </div>
                            <div className="text-dark font-weight-bolder display4 mt-2">
                              <div className="d-flex btn btn-icon btn-light  btn-sm ">
                                <span className="svg-icon svg-icon-md svg-icon-primary">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/Repair.svg"
                                    )}
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* todoList */}
              <div className={`card card-custom-dashboard pb-0 mb-10`}>
                <div className="row">
                  <div className="col-6">
                    {/* Head */}
                    <div className="card-header border-0">
                      <h3 className="card-title font-weight-bolder text-dark mb-0 ">
                        To do List
                      </h3>
                    </div>
                    {/* Body */}
                    <Table>
                      <thead>
                        <tr></tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <label
                              style={{ cursor: "pointer" }}
                              onClick={(e) =>
                                history.push(
                                  `/motor-pool/activity-monitor/type`,
                                  "RCI"
                                )
                              }
                            >
                              <b>{data.pending_rci}</b>
                            </label>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label
                              style={{ cursor: "pointer" }}
                              onClick={(e) =>
                                history.push(
                                  `/motor-pool/activity-monitor/type`,
                                  "PDI-Out"
                                )
                              }
                            >
                              <b>{data.pending_pdiout}</b>
                            </label>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <label
                              style={{ cursor: "pointer" }}
                              onClick={(e) =>
                                history.push(
                                  `/motor-pool/activity-monitor/type`,
                                  "Storage"
                                )
                              }
                            >
                              <b>{data.pending_storage}</b>
                            </label>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label
                              style={{ cursor: "pointer" }}
                              onClick={(e) =>
                                history.push(
                                  `/motor-pool/activity-monitor/type`,
                                  "Picking"
                                )
                              }
                            >
                              <b>{data.pending_picking}</b>
                            </label>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label
                              style={{ cursor: "pointer" }}
                              onClick={(e) =>
                                history.push(
                                  `/motor-pool/activity-monitor/type`,
                                  "Handover"
                                )
                              }
                            >
                              <b>{data.pending_handover}</b>
                            </label>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label
                              style={{ cursor: "pointer" }}
                              onClick={(e) =>
                                history.push(
                                  `/motor-pool/activity-monitor/type`,
                                  "Back To Storage"
                                )
                              }
                            >
                              <b>{data.pending_bts}</b>
                            </label>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label
                              style={{ cursor: "pointer" }}
                              onClick={(e) =>
                                history.push(
                                  `/motor-pool/activity-monitor/type`,
                                  "Count"
                                )
                              }
                            >
                              <b>{data.pending_stocktake}</b>
                            </label>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                setGetData(true);
                                setShow(true);
                              }}
                            >
                              <b>{data.pending_stocktake_job}</b>
                            </label>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                  <div className="col-6">
                    {/* Head */}
                    <div className="card-header border-0">
                      <h3 className="card-title font-weight-bolder text-dark  mb-0">
                        Quick Link
                      </h3>
                    </div>
                    {/* Body */}

                    <div className="card-body pt-2">
                      {dataQuikLink.map((item) => {
                        return (
                          <Link to={item.menu_url}>
                            <div className="d-flex align-items-center mb-10">
                              <div className="d-flex flex-column flex-grow-1">
                                <a
                                  className="text-dark text-hover-primary font-weight-bold font-size-lg mb-1"
                                  style={{ textDecoration: "underline" }}
                                >
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/Group.svg"
                                    )}
                                    className="mr-2"
                                  />
                                  {item.menu_name}
                                </a>
                              </div>
                            </div>
                          </Link>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>

              <ModalStocktake
                isOpen={show}
                setShow={setShow}
                setFields={setFields}
                fields={fields}
                getData={getData}
                setGetData={setGetData}
              />
            </>
          )}
        </>
      ) : (
        <></>
      )}
    </>
  );
};
